<app-hero
	[title]="'support.postBuy.title' | translate"
	imageDesktop="assets/hero/assistenza.jpg"
	imageMobile="assets/hero/assistenza_mobile.jpg"
/>

<div class="container-xxl mh-500">
	<button
		(click)="goBack()"
		class="nav-btn left text-uppercase d-lg-none mt-4"
	>
		<mat-icon>chevron_left</mat-icon>{{ "vehicle.button.back" | translate }}
	</button>

	<!-- SERVICES -->
	@if (user?.idMarket === "IT") {
		<div class="mt-4 pt-4">
			<h3 class="fw-bold mb-2 text-blue text-huge">
				{{ "bolli-pratiche.p1" | translate }}
			</h3>
		</div>

		<div class="row row-cols-1 row-cols-md-2 py-5">
			<!-- PRATICHE AUTO -->
			<div class="d-flex">
				<img
					src="assets/icons/document.svg"
					alt=""
					class="d-inline-block align-middle me-3"
					[style.width.px]="50"
				/>

				<div class="flex-grow-1">
					<div class="text-big fw-bold">{{ "pratiche-auto.title" | translate }}</div>
					<p class="mb-0">{{ "pratiche-auto.text" | translate }}</p>
					<span
						(click)="openBooklet()"
						class="ck-link ps-0"
					>
						{{ "postSales.findOutMore" | translate }}
					</span>
				</div>
			</div>

			<!-- SCADENZA BOLLO -->
			<div class="d-flex">
				<img
					src="assets/icons/money.svg"
					alt=""
					class="d-inline-block align-middle me-3"
					[style.width.px]="50"
				/>
				<div class="flex-grow-1">
					<div class="text-big fw-bold">{{ "scadenza-bollo.title" | translate }}</div>
					<p class="mb-0">{{ "scadenza-bollo.text" | translate }}</p>
					<a
						href="https://easydrive.fcagroup.com/servizi/area-leasys.aspx"
						target="_blank"
						class="ck-link ps-0"
					>
						{{ "scadenza-bollo.cta" | translate }}
					</a>
				</div>
			</div>
		</div>
	}

	<!-- REFERENCE INFO -->
	<div class="pt-4 border-top-gray">
		<h3 class="fw-bold text-blue text-huge">
			{{ "postSales.infoSeller" | translate }}
		</h3>
	</div>

	<!-- SELLER -->
	<div class="reference-block text-big">
		<div class="text-blue fw-bold mb-3 mt-4">
			{{ "postSales.referenceSeller.title" | translate }}
		</div>

		<div class="row row-cols-1 row-cols-md-3 fw-bolder contactsBg px-3">
			<span
				class="text-truncate pt-3"
				title="{{ seller?.name }} {{ seller?.surname }}"
			>
				{{ seller?.name }} {{ seller?.surname }}
			</span>
			<span
				class="text-truncate pt-3"
				[title]="seller?.mobile ?? ''"
			>
				<img
					src="assets/icons/phone.svg"
					alt=""
					[style.width.px]="30"
					class="d-inline-block align-middle"
				/>
				@if (seller?.mobile) {
					<a
						href="tel:{{ seller.mobile }}"
						class="text-basecolor"
					>
						{{ seller.mobile }}
					</a>
				}
			</span>
			<span
				class="text-truncate lineBefore py-3"
				[title]="seller?.email ?? ''"
			>
				<img
					src="assets/icons/email.svg"
					alt=""
					[style.width.px]="30"
					class="d-inline-block align-middle"
				/>
				@if (seller?.email) {
					<a
						href="mailto:{{ seller.email }}"
						class="text-basecolor"
					>
						{{ seller.email }}
					</a>
				}
			</span>
		</div>
	</div>

	<!-- AREA MANAGER -->
	<div class="reference-block text-big">
		<div class="text-blue fw-bold mb-3 mt-4">
			{{ "postSales.manager.title" | translate }}
		</div>

		<div class="row row-cols-1 row-cols-md-3 fw-bolder contactsBg px-3">
			<span
				class="text-truncate pt-3"
				title="{{ seller?.adminName }} {{ seller?.adminSurname }}"
			>
				{{ seller?.adminName }} {{ seller?.adminSurname }}
			</span>
			<span
				class="text-truncate pt-3"
				[title]="seller?.adminMobile ?? ''"
			>
				<img
					src="assets/icons/phone.svg"
					alt=""
					[style.width.px]="30"
					class="d-inline-block align-middle"
				/>
				@if (seller?.adminMobile) {
					<a
						href="tel:{{ seller.adminMobile }}"
						class="text-basecolor"
					>
						{{ seller.adminMobile }}
					</a>
				}
			</span>
			<span
				class="text-truncate lineBefore py-3"
				[title]="seller?.adminEmail ?? ''"
			>
				<img
					src="assets/icons/email.svg"
					alt=""
					[style.width.px]="30"
					class="d-inline-block align-middle"
				/>
				@if (seller?.adminEmail) {
					<a
						href="mailto:{{ seller.adminEmail }}"
						class="text-basecolor"
					>
						{{ seller.adminEmail }}
					</a>
				}
			</span>
		</div>
	</div>

	<!-- POST SALES -->
	<div class="pt-4 border-top-gray mt-5">
		<h3 class="fw-bold text-blue text-huge">
			{{ "postSales.assistance.title" | translate }}
		</h3>
	</div>

	<!-- AREA MANAGER -->
	<div class="reference-block text-big">
		<div class="row fw-bolder contactsBg px-3">
			<span class="text-truncate col-12 col-md-4 py-3">{{ "postSales.assistance.tollFreeNumber" | translate }} </span>
			<span class="text-truncate col-12 col-md-8 py-3">
				<img
					src="assets/icons/phone.svg"
					alt=""
					[style.width.px]="30"
					class="d-inline-block align-middle"
				/>
				<a
					class="text-basecolor"
					href="tel:800993017"
				>
					800 993017
				</a>
			</span>
		</div>
	</div>

	<!-- NOTES -->
	<div class="py-3">
		<div class="text-big fw-bold">
			{{ "postSales.referenceSeller.note" | translate }}
		</div>
		<div class="post-sales-notes text-sm mt-3">
			<!-- [innerHTML]="(seller?.note && (seller.note | safeHtml)) ?? null" -->
			test <br />"I clienti della provincia di Roma sono seguiti da Ivano Ceccantoni <br />E-mail: ivano.ceccantoni@leasys.com <br />Cellulare 3289895493 <br />I clienti della città di Roma sono
			seguiti da Massimo Marzioni"
		</div>
	</div>
</div>
